// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSColorPalette/ABSColor.less
// module id = 1143
// module chunks = 42